import { render } from "./InspectionResult.vue?vue&type=template&id=72e76e8b"
import script from "./InspectionResult.vue?vue&type=script&lang=js"
export * from "./InspectionResult.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__